const TEAMS_THEME_PREFIX = "teams$";

export function generateTeamsThemeId(baseThemeId: string, isV21Theme?: boolean): string {
    return `${TEAMS_THEME_PREFIX}${baseThemeId}${isV21Theme ? "$v21" : ""}`;
}

export function isTeamsThemeId(themeId: string): boolean {
    return themeId.startsWith(TEAMS_THEME_PREFIX);
}
